<template>
	<v-card tile elevation="0" style="height: 100%; overflow-y: hidden">
		<v-card-title v-if="!wizardMode" class="card-header text-left fixed-card-title2">
			<v-row dense>
				<v-col cols="10">
					<v-toolbar-title>{{ $t('copy-template') }}</v-toolbar-title>
				</v-col>
				<v-col cols="2" class="d-flex align-center justify-end">
					<v-icon color="white" @click="closeDrawer">mdi mdi-close</v-icon>
				</v-col>
			</v-row>
		</v-card-title>
		<!-- Role -->
		<v-card-text
			class="pt-4 overflow-y-auto"
			:class="{ 'pb-2': wizardMode }"
			:style="{ height: wizardMode ? 'calc(95vh - 122px)' : 'calc(100vh - 62px)' }">
			<v-row dense style="height: calc(100% + 8px)">
				<v-col cols="12" class="hp-50">
					<v-card class="hp-100">
						<v-card-title class="pt-2 pb-1">{{ $t('hospital-source') }}</v-card-title>
						<v-card-text class="pt-1 overflow-y-auto" style="height: calc(100% - 44px)">
							<v-row dense style="height: calc(100% + 8px)">
								<v-col cols="12">
									<v-autocomplete
										hide-details
										dense
										v-model="selectedSourceHospitalId"
										:items="hospitalsSource"
										item-value="id"
										item-text="hospitalName"
										:label="$t('hospital')"
										outlined
										required />
								</v-col>
								<v-col cols="12" style="height: calc(100% - 48px)" ref="dataTable" v-resize="calcDataTableHeight">
									<v-data-table
										:items="categoriesSourceItems"
										:no-data-text="$t('no-data-available')"
										:loading-text="$t('loading')"
										:loading="loading"
										:items-per-page="-1"
										:headers="headersSource"
										class="data-table-outline"
										outlined
										dense
										fixed-header
										show-select
										hide-default-footer
										:height="dataTableHeight">
										<template #[`header.data-table-select`]="{ props }">
											<v-tooltip left z-index="1000000">
												<template #activator="{ on }">
													<v-icon
														color="primary"
														@click="saveCopyTemplate()"
														:disabled="allItemsExistingInTargetHospital"
														v-bind="props"
														v-on="on">
														mdi-arrow-down-box
													</v-icon>
												</template>
												<span>
													{{ $t('copy-all-templates-to') }} "{{
														hospitalsDestination.find((a) => a.id === selectedDestinationHospitalId)?.hospitalName ||
														''
													}}"
												</span>
											</v-tooltip>
										</template>

										<template #item="{ item }">
											<tr>
												<td>
													<v-tooltip left content-class="high-tooltip">
														<template #activator="{ on }">
															<v-icon
																color="primary"
																v-on="on"
																@click="saveCopyTemplate(item.id)"
																:disabled="item.existsInDestination || !selectedDestinationHospitalId">
																mdi-arrow-down-box
															</v-icon>
														</template>
														<span>
															{{ $t('copy-template-to') }} "{{
																hospitalsDestination.find((a) => a.id === selectedDestinationHospitalId)
																	?.hospitalName || ''
															}}"
														</span>
													</v-tooltip>
												</td>
												<td class="text-left">{{ item.medicalNoteCategoryName }}</td>
											</tr>
										</template>
									</v-data-table>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>

				<v-col cols="12" class="hp-50">
					<v-card class="hp-100">
						<v-card-title class="py-2">{{ $t('hospital-destination') }}</v-card-title>
						<v-card-text style="height: calc(100% - 44px)">
							<v-row dense style="height: calc(100% + 8px)">
								<v-col cols="12">
									<v-autocomplete
										hide-details
										dense
										v-model="selectedDestinationHospitalId"
										:items="hospitalsDestination"
										item-value="id"
										item-text="hospitalName"
										:label="$t('hospital')"
										outlined
										required />
								</v-col>
								<v-col cols="12" style="height: calc(100% - 48px)">
									<v-data-table
										:items="categoriesDestinationItems"
										:no-data-text="$t('no-data-available')"
										:loading-text="$t('loading')"
										:loading="targetHospitalLoader"
										:items-per-page="-1"
										:headers="headersDestination"
										class="data-table-outline"
										outlined
										dense
										fixed-header
										hide-default-footer
										:height="dataTableHeight">
										<template #item="{ item }">
											<tr>
												<td class="text-left">{{ item.medicalNoteCategoryName }}</td>
												<td>
													<v-icon size="20" @click.stop="deassignTemplateSourceHospital(item.id)" color="primary">
														mdi-delete
													</v-icon>
												</td>
											</tr>
										</template>
									</v-data-table>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
	name: 'MedicalNoteCategoryCopyTemplate',
	components: {},
	props: {
		wizardMode: {
			type: Boolean,
			default: false,
		},
		wizardData: {
			type: Object,
			default: () => ({}),
		},
		dataPros: {
			type: Object,
			default: null,
			required: false,
		},
	},
	data: () => ({
		selectedSourceHospitalId: null,
		selectedDestinationHospitalId: null,
		categoriesSourceItems: [],
		categoriesDestinationItems: [],
		loading: false,
		targetHospitalLoader: false,
		allItemsExistingInTargetHospital: true,
		dataTableHeight: 200,
	}),

	computed: {
		...mapState({
			hospitals: (state) => state.hospitals.hospitals,
			userData: (state) => state.authentication.userData,
			medicalStaffAssignedHospitals: (state) => state.hospitals.medicalStaffAssignedHospitals,
		}),
		...mapGetters({
			pageHeight: 'pageHeight',
		}),
		headersSource () {
			return [
				{
					text: this.$t('medical-note-category-name'),
					sortable: true,
					align: 'start',
				},
			];
		},
		headersDestination () {
			return [
				{
					text: this.$t('medical-note-category-name'),
					sortable: true,
					align: 'start',
				},
				{
					text: '',
					sortable: true,
					align: 'start',
				},
			];
		},
		hospitalsSource () {
			return this.hospitals || []; // this.$store.state?.hospitals?.hospitals || [];
		},
		hospitalsDestination () {
			if (this.wizardMode) {
				this.selectedDestinationHospitalId = this.wizardData.id;
				this.$emit('update:hospitalsDestination', [this.wizardData]);
				return [this.wizardData];
			}
			return this.selectedSourceHospitalId !== null
				? this.hospitals?.filter((h) => h.id !== this.selectedSourceHospitalId) || []
				: [];
		},
	},
	mounted () {
		this.getHospitals();
		this.calcDataTableHeight();
	},
	methods: {
		async getHospitals () {
			this.loading = true;
			await this.$store.dispatch('hospitals/getHospitals').then(() => {
				this.loading = false;
			});
		},
		closeDrawer () {
			this.selectedSourceHospitalId = null;
			this.selectedDestinationHospitalId = null;
			this.categoriesSourceItems = [];
			this.categoriesDestinationItems = [];
			this.$store.commit('SET_DETAILS_DRAWER', false);
		},
		async saveCopyTemplate (itemId) {
			const body = {
				organizationId: ['SYSTEM_ADMIN', 'SYSTEM_USER'].includes(this.userData.roleData.roleName) ? this.dataPros.pccCompaniesMapping[0].mappedCompanyId : this.userData.organizationId,
				sourcelocationId: this.selectedSourceHospitalId,
				targetLocationId: this.selectedDestinationHospitalId,
				templatesToCopyToTargetLocationId: itemId ? [itemId] : this.categoriesSourceItems.map((m) => m.id),
			};

			this.$store
				.dispatch('medicalnotecategory/copyMedicalNoteCategoryTemplateFromLocationIdToLocationid', body)
				.then((res) => {
					this.categoriesDestinationItems = res.data;
					this.$store
						.dispatch('medicalnotecategory/medicalnotecategorytemplateforhospital', this.selectedDestinationHospitalId)
						.then((res) => {
							this.categoriesDestinationItems = res;
							this.compareExistenceInSourceAndTargetHospital();
						});
				});
		},
		deassignTemplateSourceHospital (itemId) {
			this.targetHospitalLoader = true;
			this.$store
				.dispatch('medicalnotecategory/deletemedicalnotecategorytemplate', itemId)
				.then((res) => {
					this.$store
						.dispatch('medicalnotecategory/medicalnotecategorytemplateforhospital', this.selectedDestinationHospitalId)
						.then((res) => {
							this.categoriesDestinationItems = res;
							this.compareExistenceInSourceAndTargetHospital();
							this.targetHospitalLoader = false;
						});
				})
				.catch(() => {
					this.targetHospitalLoader = false;
				});
		},
		checkIfAllItemsExistInTargetHospital () {
			if (!this.categoriesSourceItems?.length || !this.selectedDestinationHospitalId) {
				return; // no items to compare
			}
			// Make a Set of all destination types for fast lookup
			const destinationTypes = new Set(this.categoriesDestinationItems.map((item) => item.medicalNoteCategoryType));

			// Check if every source type is in destination
			this.allItemsExistingInTargetHospital = this.categoriesSourceItems.every((item) => {
				return destinationTypes.has(item.medicalNoteCategoryType);
			});
		},
		compareExistenceInSourceAndTargetHospital () {
			// First, create a Set of types from the destination array
			const destinationTypes = new Set(this.categoriesDestinationItems.map((item) => item.medicalNoteCategoryType));
			// Now, map through the source array and add a new property `existsInDestination`
			const updatedSource = this.categoriesSourceItems.map((item) => ({
				...item,
				existsInDestination: destinationTypes.has(item.medicalNoteCategoryType),
			}));
			this.categoriesSourceItems = updatedSource;
			this.checkIfAllItemsExistInTargetHospital();
		},
		calcDataTableHeight () {
			this.$nextTick(() => {
				if (this.$refs.dataTable) {
					this.dataTableHeight = this.$refs.dataTable.clientHeight - 8;
				}
			});
		},
	},
	watch: {
		selectedSourceHospitalId (val) {
			if (val !== null) {
				this.$store.dispatch('medicalnotecategory/medicalnotecategorytemplateforhospital', val).then((res) => {
					// Map the response and add existsInDestination = false
					this.categoriesSourceItems = res.map((item) => ({
						...item,
						existsInDestination: false,
					}));

					this.compareExistenceInSourceAndTargetHospital();
				});
			}
		},
		selectedDestinationHospitalId (val) {
			if (val !== null) {
				this.targetHospitalLoader = true;
				this.$store
					.dispatch('medicalnotecategory/medicalnotecategorytemplateforhospital', val)
					.then((res) => {
						this.categoriesDestinationItems = res;
						this.compareExistenceInSourceAndTargetHospital();
						this.targetHospitalLoader = false;
					})
					.catch(() => {
						this.targetHospitalLoader = false;
					});
			}
		},
		categoriesDestinationItems (newVal) {
			this.$emit('update:categoriesDestinationItems', newVal);
		},
	},
};
</script>
<style scoped>
.v-overlay__content {
	z-index: 5000 !important;
}

.v-navigation-drawer {
	overflow: visible !important;
}

.high-tooltip.v-tooltip__content,
.high-tooltip {
	z-index: 99999 !important;
	position: absolute;
}
</style>
